const PIXI = require('pixi.js');
const SizesUtils = require('../../../viscomjs/utils/SizesUtils');

// INITIAL CONSTRUCT AND CONFIG

function _construct(container) {
    if (!container) return null;

    const app = new PIXI.Application({
        width: SizesUtils.winOffsetWidth(),
        height: SizesUtils.winOffsetHeight(),
        autoStart: false,
        antialias: true,
        resolution: window.devicePixelRatio || 1,

        backgroundColor: 0x000000,
        // transparent: true,
        // forceCanvas: true,
        // sharedTicker: false,
        sharedLoader: false
    });

    container.appendChild(app.view);
    return app;
}

function _config(app) {
    if (!app) return null;

    // To make sure the canvas is resized to match the resolution:
    app.renderer.autoResize = true;

    return app;
}

/* --------------------- */

// window resize control

function _startResize(app, size, align) {

    const _resizeControl = () => {
        const w = SizesUtils.winOffsetWidth();
        const h = SizesUtils.winOffsetHeight();

        if (size) {
            const w0 = size.width;
            const h0 = size.height;
            const sW = w / w0;
            const sH = h / h0;
            const position = {x: 0, y: 0};
            const scale = Math.max(sW, sH);
            app.stage.scale.x = app.stage.scale.y = scale;

            switch (align) {
                case 'B':
                case 'BL':
                case 'BR':
                    position.y = h - h0 * scale;
                    break;
                case 'L':
                case 'R':
                case '':
                    position.y = Math.floor((h - h0 * scale) / 2);
                    break;
            }

            switch (align) {
                case 'R':
                case 'BR':
                case 'TR':
                    position.x = w - w0 * scale;
                    break;
                case 'T':
                case 'B':
                case '':
                    position.x = Math.floor((w - w0 * scale) / 2);
                    break;
            }
            app.stage.position.x = position.x;
            app.stage.position.y = position.y;

        }
        app.renderer.resize(w, h);
        // console.log('Canvas resized', SizesUtils.winOffsetWidth(), SizesUtils.winOffsetHeight());
    }

    setTimeout(_resizeControl, 100);
    window.addEventListener('resize', _resizeControl);
    return app;
}

/* --------------------- */

function _start(app) {
    app.start();
    return app;
}

function _stop(app) {
    app.stop();
    return app;
}

const App = function (container, config = null, resize = true, autoStart = false) {
    let f1 = a => {return a;};
    let f2 = f1;
    let size = null;
    let align = '';
    if (config) {
        if (config.width && config.height) size = {width: config.width, height: config.height};
        if (config.align) align = config.align;
    }
    if (resize) f1 = a => {return _startResize(a, size, align);};
    if (autoStart) f2 = _start;

    const app = f2(f1(_config(_construct(container))));

    return {
        instance: app,
        start: () => {
            _start(app);
        },
        stop: () => {
            _stop(app);
        },
        startResize: () => {
            _startResize(app, size, align);
        }
    };
}

module.exports = App;


// WEBPACK FOOTER //
// ./js/viscom/boss/soccers/app/App.js